import { Stack, Text } from '@mantine/core';
import { UiNode, UiNodeInputAttributes } from '@ory/client';
import { OidcFormButton } from 'src/components/convenience/auth/OidcFormButton';

type OidcAction = 'provider' | 'link' | 'unlink';

interface OidcSectionProps {
  nodes: UiNode[];
  formAction: string;
  csrfToken: string;
  action?: OidcAction;
  title?: string;
  gap?: 'xs' | 'sm' | 'md' | 'lg';
}

export const OidcSection = ({
  nodes,
  formAction,
  csrfToken,
  action,
  title,
  gap = 'xs',
}: OidcSectionProps) => {
  if (nodes.length === 0) return null;

  return (
    <>
      {title && (
        <Text size="sm" c="gray.6" ta="center">
          {title}
        </Text>
      )}
      <Stack gap={gap}>
        {nodes.map(node => (
          <OidcFormButton
            key={(node.attributes as UiNodeInputAttributes).value as string}
            node={node}
            formAction={formAction}
            csrfToken={csrfToken}
            action={action}
          />
        ))}
      </Stack>
    </>
  );
};
